import SubModuleContent from './SubModuleContent';

export default SubModuleContent;
